import { render } from "./StockCodeDisplay.vue?vue&type=template&id=48e0ec4d&scoped=true&ts=true"
import script from "./StockCodeDisplay.vue?vue&type=script&lang=ts"
export * from "./StockCodeDisplay.vue?vue&type=script&lang=ts"

import "./StockCodeDisplay.vue?vue&type=style&index=0&id=48e0ec4d&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e0ec4d"]])

export default __exports__